import {
  Config,
  ConfigResponseMode,
  OneTap,
  WidgetEvents,
  OneTapInternalEvents
} from '@vkid/sdk';
import { authWithVK } from '@/entities/user/lib/authWithVK';
import { generateCodeVerifier } from '@/shared/lib/utils/generateCodeVerifier';
import { useUserStore } from '@/entities/user/model/userStore';
import router from '@/app/router'

interface VKLoginPayload {
  code: string;
  deviceId: string;
  state: string;
}

export function useVKID() {
  const codeVerifier = generateCodeVerifier();

  Config.init({
    app: window.APP_CONFIG.VK_APP_ID,
    redirectUrl: window.APP_CONFIG.VK_REDIRECT_URI,
    responseMode: ConfigResponseMode.Callback,
    codeVerifier,
    scope: 'groups',
  });
  const oneTap = new OneTap();
  const render = (container: HTMLElement) => {
    if (window.APP_CONFIG.TEST_AUTH_ON) {
      auth()
      return;
    }
    oneTap
      .render({
        container,
        showAlternativeLogin: false,
      })
      .on(WidgetEvents.ERROR, console.error)
      .on(OneTapInternalEvents.LOGIN_SUCCESS, (payload: VKLoginPayload) => {
        console.log('[VKID] LOGIN_SUCCESS');
        void authWithVK({
          code: payload.code,
          deviceId: payload.device_id,
          state: payload.state,
          codeVerifier,
          redirectUri: window.APP_CONFIG.VK_REDIRECT_URI,
        }).catch(console.error);
      });
  };

  return { render };
}

async function auth() {
  const req = await fetch(`${window.APP_CONFIG.API_URL}/api/authTest`);
  const res = await req.json();
  const token = res.token;
  const refreshToken = res.refreshToken;
  const tokenTtl = Number(res.tokenTtl);
  const tokenGot = Math.floor(Date.now() / 1000) - 10;

  const me = await fetch(`${window.APP_CONFIG.API_URL}/api/me`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const userData = await me.json();
  const { displayName, vkFirstName, vkLastName, avatarUrl, id, isDon, settingsJson } = userData;

  const name = displayName || `${vkFirstName ?? ''} ${vkLastName ?? ''}`.trim();
  const avatar = avatarUrl || '';

  const userStore = useUserStore();
  userStore.setUser({ name, token, refreshToken, tokenTtl, tokenGot, avatar, id, isDon, settingsJson });
  router.go();
}
